module.exports = __webpack_public_path__ + "static/IBMPlexSans-MediumItalic-362cab3c408c2cb716d79abaa43e1889.woff2";